import React from 'react';
import { CheckCircle, ShieldCheck } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Hero() {
  const features = ['PDF Digital', 'Acceso Inmediato', 'Recetas fáciles y saludables', 'Para toda la familia'];
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-79">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-80">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-81">
          {/* Left Column - Content */}
          <div className="max-w-2xl" data-id="element-82">
            <FadeIn data-id="element-83">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-100 text-brand-700 text-sm font-semibold mb-6" data-id="element-84">
                <span className="w-2 h-2 rounded-full bg-brand-500 animate-pulse" data-id="element-85"></span>
                6 Módulos + 6 Bonos Exclusivos
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-86">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-950 leading-tight mb-6" data-id="element-87">
                RECETAS SALUDABLES PARA CELÍACOS
                <span className="block text-brand-600 mt-2 text-3xl md:text-4xl lg:text-5xl" data-id="element-88">
                  Tu Alimentación Sin Gluten Resuelta
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-89">
              <p className="text-lg md:text-xl text-brand-800/80 mb-8 leading-relaxed" data-id="element-90">
                Tu sistema completo de alimentación saludable sin gluten listo
                para usar: recetas, planificación, colaciones, hábitos
                saludables y organización diaria. Sin estrés, sin improvisar y
                sin poner en riesgo tu salud.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-91">
              <ul className="grid sm:grid-cols-2 gap-4 mb-10" data-id="element-92">
                {features.map((feature, idx) => <li key={idx} className="flex items-center gap-3 text-brand-900 font-medium" data-id="element-93">
                    <CheckCircle className="w-5 h-5 text-brand-500 flex-shrink-0" data-id="element-94" />
                    <span data-id="element-95">{feature}</span>
                  </li>)}
              </ul>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-96">
              <div className="flex flex-col sm:flex-row gap-4 items-center" data-id="element-97">
                <a href="#oferta" className="w-full sm:w-auto px-8 py-4 bg-brand-600 hover:bg-brand-700 text-white rounded-2xl font-bold text-lg transition-all transform hover:scale-[1.02] hover:shadow-soft-lg text-center shadow-soft" data-id="element-98">
                  QUIERO MI ALIMENTACIÓN SALUDABLE AHORA
                </a>
              </div>

              <div className="mt-6 flex items-center gap-2 text-sm text-brand-700 font-medium justify-center sm:justify-start" data-id="element-99">
                <ShieldCheck className="w-5 h-5 text-brand-500" data-id="element-100" />
                <span data-id="element-101">
                  Pago seguro Mercado Pago · Miles de personas mejorando su vida
                  sin gluten 💚
                </span>
              </div>
            </FadeIn>
          </div>

          {/* Right Column - Image */}
          <FadeIn delay={0.2} direction="left" className="relative lg:h-[600px] rounded-3xl overflow-hidden shadow-soft-lg group" data-id="element-102">
            <div className="absolute inset-0 bg-brand-900/10 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-103"></div>
            <img src="https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&q=80&w=1000" alt="Plato saludable sin gluten" className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-700" data-id="element-104" />

            {/* Floating Badge */}
            <div className="absolute bottom-6 left-6 right-6 bg-white/90 backdrop-blur-sm p-4 rounded-2xl shadow-lg z-20 flex items-center gap-4 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-500" data-id="element-105">
              <div className="w-12 h-12 bg-brand-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-106">
                <CheckCircle className="w-6 h-6 text-brand-600" data-id="element-107" />
              </div>
              <div data-id="element-108">
                <p className="font-bold text-brand-950" data-id="element-109">100% Libre de Gluten</p>
                <p className="text-sm text-brand-700" data-id="element-110">
                  Recetas probadas y seguras
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>

      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 -translate-y-12 translate-x-1/3 w-[800px] h-[800px] bg-brand-50 rounded-full blur-3xl opacity-50 -z-10" data-id="element-111"></div>
      <div className="absolute bottom-0 left-0 translate-y-1/3 -translate-x-1/3 w-[600px] h-[600px] bg-cream-300 rounded-full blur-3xl opacity-50 -z-10" data-id="element-112"></div>
    </section>;
}